<template>
  <div class="d-flex justify-center">
    <v-dialog
      v-model="dialog"
      flat
      persistent
      max-width="400"
      content-class="br_none"
    >
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text class="d-flex align-center justify-center"><span v-html="text" style="color:#000; font-size:16px!important;word-break:break-word;"></span></v-card-text>
        <v-card-actions class="d-flex align-center justify-center pb-15">
          <v-spacer></v-spacer>
          <v-btn class="sb_btn" width="110" @click="dialog = false" dark color="#2a58ad">{{btn.text}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import eventBus from '@/utils/eventBus'
import utils from '@/utils/utils'

export default {
  name: 'Dialog',
  props: {
  },
  components: {
  },
  data () {
    return {
      dialog: false,
      title: '',
      text: '',
      btn: {
        text: '',
      }
    }
  },
  mounted () {
    eventBus.$off('CLOSE_DIALOG')
    eventBus.$on('CLOSE_DIALOG', () => {
      this.dialog = false
    })

    eventBus.$off('SHOW_DIALOG')
    eventBus.$on('SHOW_DIALOG', (options) => {
      this.text = options.text
      this.btn = {
        text: (options.btn) ? options.btn.text: ''
      }

      if (utils.isNull(this.btn.text)) {
        this.btn.text = this.$t('common.button.ok')
      }

      this.dialog = true
    })


    eventBus.$off('SHOW_SNACKBAR')
    eventBus.$on('SHOW_SNACKBAR', (options) => {
      this.text = options.text
      this.btn = {
        text: (options.btn) ? options.btn.text: ''
      }

      if (utils.isNull(this.btn.text)) {
        this.btn.text = this.$t('common.button.ok')
      }

      this.dialog = true
    })


  },
  methods: {
  }
}

</script>